import { render, staticRenderFns } from "./accessoryManagement.vue?vue&type=template&id=1faef1d5&scoped=true&"
import script from "./accessoryManagement.vue?vue&type=script&lang=js&"
export * from "./accessoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./accessoryManagement.vue?vue&type=style&index=0&id=1faef1d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faef1d5",
  null
  
)

export default component.exports